import RangeInput from './component';
import { RangeInputProps } from './types';

export type { RangeInputProps };
export default RangeInput;
